module.exports = __webpack_public_path__ + "199cb9c173870d6e9e212db8e9357a20.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/imgs/lexus.png
 ** module id = 593
 ** module chunks = 0
 **/